import { useModeList } from "../../hooks/ModeHook"
import { usePageTitle } from "../../hooks/TitleHook"
import LayoutItem from "../../layoutBuilder/LayoutItem"
import LayoutWrapper from "../../layoutBuilder/LayoutWrapper"
import AllEmissionsByMode from "../../components/Charts/Wireups/AllEmissionsByMode"
import GraphTitle from "../../components/ChartsVisX/shared/GraphTitle"
import { useTheme } from "@mui/system"
import AllEmissionsByModeDonut from "../../components/Charts/Wireups/AllEmissionsByModeDonut"
import GroupByDonut from "../../components/Charts/Wireups/GroupByDonut"
import { usePartnerAtomValue } from "../../hooks/PartnerHooks"
import { useAtomValue } from "jotai"
import { userAtom } from "../../atoms/user"

const globalItemStyle = {
	lg: 6,
	xl: 6,
	minHeight: 220,
	elevation: 0,
	innerStyle: { padding: 0 },
}

const TravelView = () => {
	const theme = useTheme()
	const outerStyle = { marginTop: theme.spacing(3) }

	return (
		<LayoutItem>
			<GraphTitle title="Emissions - Travel breakdown" subTitle={"Data source: BlueHalo"} />
			<LayoutWrapper style={{ padding: theme.spacing(2, 2, 0, 2), marginBottom: 0 }}>
				<LayoutItem {...globalItemStyle} outerStyle={{ ...outerStyle, padding: theme.spacing(0, 2, 0, 0) }}>
					<AllEmissionsByModeDonut />
				</LayoutItem>
			</LayoutWrapper>
		</LayoutItem>
	)
}

const AirRetirementsView = () => {
	const theme = useTheme()
	const outerStyle = { marginTop: theme.spacing(3) }

	return (
		<LayoutItem>
			<GraphTitle title="Emissions - Flight breakdown" subTitle={"Data source: BlueHalo"} />
			<LayoutWrapper style={{ padding: theme.spacing(2, 2, 0, 2), marginBottom: 0 }}>
				<LayoutItem {...globalItemStyle} outerStyle={{ ...outerStyle, padding: theme.spacing(0, 2, 0, 0) }}>
					<GroupByDonut title={"By travel class"} groupBy="travelclass" modeOverride={["airEmissions"]} />
				</LayoutItem>
			</LayoutWrapper>
		</LayoutItem>
	)
}

const AccommodationView = () => {
	const theme = useTheme()
	const outerStyle = { marginTop: theme.spacing(3) }

	return (
		<LayoutItem>
			<GraphTitle title="Emissions - Accommodation breakdown" subTitle={"Data source: BlueHalo"} />
			<LayoutWrapper style={{ padding: theme.spacing(2, 2, 0, 2), marginBottom: 0 }}>
				<LayoutItem {...globalItemStyle} outerStyle={{ ...outerStyle, padding: theme.spacing(0, 2, 0, 0) }}>
					<GroupByDonut title={"By star rating"} groupBy="starrating" modeOverride={["accommodationEmissions"]} DonutProps={{ DonutLegendProps: { keyClasses: "" } }} />
				</LayoutItem>
				<LayoutItem {...globalItemStyle} outerStyle={{ ...outerStyle, padding: theme.spacing(0, 0, 0, 2) }}>
					<GroupByDonut title={"By country"} groupBy="country" modeOverride={["accommodationEmissions"]} DonutProps={{ DonutLegendProps: { keyClasses: "txt-transform-uppercase" } }} />
				</LayoutItem>
			</LayoutWrapper>
		</LayoutItem>
	)
}

const RoadView = () => {
	const theme = useTheme()
	const outerStyle = { marginTop: theme.spacing(3) }

	return (
		<LayoutItem>
			<GraphTitle title="Emissions - Car Rental breakdown" subTitle={"Data source: BlueHalo"} />
			<LayoutWrapper style={{ padding: theme.spacing(2, 2, 0, 2), marginBottom: 0 }}>
				<LayoutItem {...globalItemStyle} outerStyle={{ ...outerStyle, padding: theme.spacing(0, 2, 0, 0) }}>
					<GroupByDonut title={"By number of rental days"} groupBy="rentalDays" modeOverride={["roadEmissions"]} />
				</LayoutItem>
				<LayoutItem {...globalItemStyle} outerStyle={{ ...outerStyle, padding: theme.spacing(0, 0, 0, 2) }}>
					<GroupByDonut title={"By car classification code (ACRISS code)"} groupBy="acrisCode" modeOverride={["roadEmissions"]} DonutProps={{ DonutLegendProps: { keyClasses: "txt-transform-uppercase" } }} />
				</LayoutItem>
			</LayoutWrapper>
		</LayoutItem>
	)
}

const Emissions = () => {
	usePageTitle("BlueHalo - Emissions")
	const modes = useModeList()
	const partner = usePartnerAtomValue()
	const user = useAtomValue(userAtom)

	// For admin users, only show content if partner is selected
	// For non-admin users, always show content
	const shouldShowContent = user.isAdmin ? Boolean(partner) : true

	if (!modes) return null

	return (
		<LayoutWrapper>
			{shouldShowContent && (
				<>
					<LayoutItem minHeight={300}>
						<AllEmissionsByMode />
					</LayoutItem>
					{modes.length > 1 && <TravelView />}
					{modes.map((mode) => {
						switch (mode) {
							case "air":
								return <AirRetirementsView key={"view-1"} />
							case "accommodation":
								return <AccommodationView key={"view-2"} />
							case "road":
								return <RoadView key={"view-3"} />
							default:
								return <></>
						}
					})}
				</>
			)}
		</LayoutWrapper>
	)
}

export default Emissions
